import React from 'react';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';

import ListGroup, { ListItem } from '../ListGroup';
import ListItemSubtitleText from '../ListItemSubtitleText';

import { Subtitle2 } from '../Typography';
import { ReactComponent as WarningIcon } from '../../assets/svg/important-red.svg';
import { ReactComponent as SuccessIcon } from '../../assets/svg/success-icon.svg';

import styles from './index.module.scss';

export enum IconType {
  WARNING = 'warning',
  SUCCESS = 'success',
}

const iconMap: Record<
  IconType,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  [IconType.WARNING]: WarningIcon,
  [IconType.SUCCESS]: SuccessIcon,
};

export interface ListGroupContent {
  title?: string;
  items: ListItem[];
}

export interface BannerWithListProps {
  title: string;
  iconType: IconType;
  listGroups: ListGroupContent[];
  note?: string;
  className?: string;
}

const BannerWithList: React.FC<BannerWithListProps> = ({
  title,
  iconType,
  listGroups,
  note,
  className,
}) => {
  const Icon = iconMap[iconType];

  return (
    <div className={cx({ [styles.wrapper]: true }, className)}>
      <div className={styles.header}>
        <Subtitle2 className={styles.title}>
          <FormattedMessage id={title} />
        </Subtitle2>
      </div>

      <div className={styles.list}>
        {listGroups.map((group, index) => (
          <ListGroup
            key={index}
            groupTitle={group.title}
            items={group.items}
            icon={<Icon />}
          />
        ))}
      </div>

      {note && <ListItemSubtitleText classsName={styles.note} text={note} />}
    </div>
  );
};

export default BannerWithList;
